import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconService } from '@shared/common/services/icon/icon.service';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  standalone: false
})
export class MenuListItemComponent {
  @Input() menuId: string;
  @Input() menuIcon: string;
  @Input() menuText: string;
  @Input() title: string;
  @Input() routePath = '';
  @Input() isExternalLink: boolean;
  @Input() showLinkIcon: boolean;
  @Input() role: 'link' | 'button' = 'link';

  @Output() onClick: EventEmitter<Event> = new EventEmitter();

  constructor(public iconService: IconService) {}
}
